import React, { useState } from "react";
import WishlistBookButton from "./WishlistBookButton";
import WishlistButton from "./WishlistButton";

import { useTranslation } from "../../context/TranslationContext";
import SectionTabs from "../../component/SectionTabs"; 
function MyFav() {
  const [selectedSection, setSelectedSection] = useState("books");
  const { translations, language } = useTranslation();
  const isArabic = language === "ar";

  const handleSectionChange = (e) => {
    setSelectedSection(e.target.value);
  };

  const sections = {
    books: { label: translations.wishlistBook },
    courses: { label: translations.wishlistcourse },
  };

  return (
    <>
      <div
        className={`flex ${
          isArabic
            ? "flex-col md:flex-row"
            : "flex-col-reverse md:flex-row-reverse"
        } pt-16 w-full`}
      >
        <div
          className="pt-10 flex-1"
          style={{
            fontFamily: "Tajwal, sans-serif",
            direction: isArabic ? "rtl" : "ltr",
            textAlign: isArabic ? "right" : "left",
          }}
        >
          <h2 className="text-xl font-bold mb-1">{translations.myWishlist}</h2>
          <h4 className="text-l font-bold text-gray-500">
            {translations.wishListDetails}
          </h4>

  
          <div className="hidden sm:flex flex-wrap justify-center md:justify-start mt-4 gap-2">
            <button
              className={`flex items-center px-4 py-2 bg-blue rounded-lg text-l font-bold text-gray-900 hover:bg-primary-blue hover:text-white focus:outline-none ${
                selectedSection === "books"
                  ? "bg-primary-blue text-white"
                  : ""
              }`}
              onClick={() => setSelectedSection("books")}
            >
              {translations.wishlistBook}
            </button>
            <button
              className={`flex items-center px-4 py-2 bg-blue rounded-lg text-l font-bold text-gray-900 hover:bg-primary-blue hover:text-white focus:outline-none ${
                selectedSection === "courses"
                  ? "bg-primary-blue text-white"
                  : ""
              }`}
              onClick={() => setSelectedSection("courses")}
            >
              {translations.wishlistcourse}
            </button>
          </div>

      
          <SectionTabs
            sections={sections}
            selectedSection={selectedSection}
            onChange={handleSectionChange}
          />

         
          <div className="mt-4">
            {selectedSection === "books" && <WishlistBookButton />}
            {selectedSection === "courses" && <WishlistButton />}
          </div>
        </div>
      </div>
    </>
  );
}

export default MyFav;
